// Route constants for the application
export default {
  INIT: '/init', // Path for the welcome route
  ONBOARDING: '/onboarding', // Path for the onboarding route
  LOGIN: 'auth/login', // Path for the login route
  REGISTER: 'auth/register', // Path for the registration route
  CONFIRM_EMAIL: 'auth/confirm-email', // Path for the email confirmation route
  EMAIL_CONFIRMED: 'auth/email-confirmed', // Path for the email confirmation route
  FORGOT_PASSWORD: 'auth/forgot-password', // Path for the forgot password route
  FORGOT_PASSWORD_CONFIRM: 'auth/forgot-password-confirm', // Path for the forgot password confirmation route
  CULTIVATIONS: 'garden/cultivation',
  HOME: '/home',
  AGENDA: '/agenda',
  AGENDA_TASKS: '/agenda/tasks',
  AGENDA_ARCHIVES: '/agenda/archives',
  GARDEN: '/garden',
  GARDEN_LIST: '/garden/list',
  GARDEN_SEEDS: '/garden/seeds',
  USER_ADD_SEED_SCAN: '/garden/add-seeds/scan',
  USER_ADD_SEED_SELECT: '/garden/add-seeds/select',
  GARDEN_ADDPLANT: '/garden/add-plant',
  GARDEN_GUIDE: '/garden/guide',
  ARTICLES: '/articles',
  GARDEN_BEDS: '/garden/beds',
  GARDEN_BED_CREATE: '/garden/beds/create',
  GARDEN_HISTORY: '/garden/history',
  PROFILE: '/profile',
  CALENDAR: '/calendar',
  LUNAR: '/lunar',
  WEATHER: '/weather',
  CALENDAR_SEEDLING: '/calendar/seedling',
  CALENDAR_HARVEST: '/calendar/harvest',
  FEEDBACK: '/feedback',
  NOTIFICATIONS: '/notifications',
};
